import { Color } from "../../models/shared/formats/Color";

// Color

// BackgroundColor
/* eslint-disable sort-keys*/
export const backgroundColorFormatByEncodedValue = {
  64: Color.GREY_4,
  // BLACK
  128: Color.BROWN_3,
  // BROWN
  384: Color.BLUE_4,
  // DARK_BLUE
  576: Color.RED_4,
  // DARK_RED
  640: Color.ORANGE_3,
  // ORANGE
  768: Color.GREEN_4,
  // GREEN
  896: Color.BLUE_3,
  // BLUE
  1024: Color.GREY_3,
  // GREY_50_PRECENT
  1088: Color.RED_3,
  // RED
  1216: Color.GREEN_2,
  // LIME
  1472: Color.PURPLE_4,
  // VIOLET
  1600: Color.RED_2,
  // PINK
  1664: Color.YELLOW_4,
  // GOLD
  1728: Color.YELLOW_2,
  // YELLOW
  1792: Color.GREEN_3,
  // BRIGHT_GREEN
  1984: Color.PURPLE_3,
  // PLUM
  2048: Color.GREY_2,
  // GREY_25_PERCENT
  2176: Color.ORANGE_2,
  // TAN
  2240: Color.YELLOW_1,
  // LIGHT_YELLOW
  2304: Color.GREEN_1,
  // LIGHT_GREEN
  2368: Color.BLUE_1,
  // LIGHT_TURQUOISE
  2432: Color.BLUE_2,
  // PALE_BLUE
  2496: Color.PURPLE_2,
  // LAVENDER
  2560: Color.GREY_0,
  // WHITE
  2624: Color.TRANSPARENT,
  2688: Color.RED_0,
  2752: Color.ORANGE_0,
  2816: Color.YELLOW_0,
  2880: Color.GREEN_0,
  2944: Color.BLUE_0,
  3008: Color.PURPLE_0,
  3072: Color.BROWN_0,
  3136: Color.RED_1,
  3200: Color.ORANGE_1,
  3264: Color.PURPLE_1,
  3328: Color.BROWN_1,
  3392: Color.GREY_1,
  3456: Color.BROWN_2,
  3520: Color.YELLOW_3,
  3584: Color.ORANGE_4,
  3648: Color.BROWN_4,
  // LEGACY COLORS
  // no longer in palette but preserved for mapping to new colors
  192: Color.LEGACY_OLIVE_GREEN,
  256: Color.LEGACY_DARK_GREEN,
  320: Color.LEGACY_DARK_TEAL,
  448: Color.LEGACY_INDIGO,
  512: Color.LEGACY_GREY_80_PERCENT,
  704: Color.LEGACY_DARK_YELLOW,
  832: Color.LEGACY_TEAL,
  960: Color.LEGACY_BLUE_GREY,
  1152: Color.LEGACY_LIGHT_ORANGE,
  1280: Color.LEGACY_SEA_GREEN,
  1344: Color.LEGACY_AQUA,
  1408: Color.LEGACY_LIGHT_BLUE,
  1536: Color.LEGACY_GREY_40_PERCENT,
  1856: Color.LEGACY_TURQUOISE,
  1920: Color.LEGACY_SKY_BLUE,
  2112: Color.LEGACY_ROSE
};
export const encodedValueByBackgroundColorFormat = {
  [Color.GREY_4]: 64,
  // BLACK
  [Color.BROWN_3]: 128,
  // BROWN
  [Color.BLUE_4]: 384,
  // DARK_BLUE
  [Color.RED_4]: 576,
  // DARK_RED
  [Color.ORANGE_3]: 640,
  // ORANGE
  [Color.GREEN_4]: 768,
  // GREEN
  [Color.BLUE_3]: 896,
  // BLUE
  [Color.GREY_3]: 1024,
  // GREY_50_PRECENT
  [Color.RED_3]: 1088,
  // RED
  [Color.GREEN_2]: 1216,
  // LIME
  [Color.PURPLE_4]: 1472,
  // VIOLET
  [Color.RED_2]: 1600,
  // PINK
  [Color.YELLOW_4]: 1664,
  // GOLD
  [Color.YELLOW_2]: 1728,
  // YELLOW
  [Color.GREEN_3]: 1792,
  // BRIGHT_GREEN
  [Color.PURPLE_3]: 1984,
  // PLUM
  [Color.GREY_2]: 2048,
  // GREY_25_PERCENT
  [Color.ORANGE_2]: 2176,
  // TAN
  [Color.YELLOW_1]: 2240,
  // LIGHT_YELLOW
  [Color.GREEN_1]: 2304,
  // LIGHT_GREEN
  [Color.BLUE_1]: 2368,
  // LIGHT_TURQUOISE
  [Color.BLUE_2]: 2432,
  // PALE_BLUE
  [Color.PURPLE_2]: 2496,
  // LAVENDER
  [Color.GREY_0]: 2560,
  // WHITE
  [Color.TRANSPARENT]: 2624,
  [Color.RED_0]: 2688,
  [Color.ORANGE_0]: 2752,
  [Color.YELLOW_0]: 2816,
  [Color.GREEN_0]: 2880,
  [Color.BLUE_0]: 2944,
  [Color.PURPLE_0]: 3008,
  [Color.BROWN_0]: 3072,
  [Color.RED_1]: 3136,
  [Color.ORANGE_1]: 3200,
  [Color.PURPLE_1]: 3264,
  [Color.BROWN_1]: 3328,
  [Color.GREY_1]: 3392,
  [Color.BROWN_2]: 3456,
  [Color.YELLOW_3]: 3520,
  [Color.ORANGE_4]: 3584,
  [Color.BROWN_4]: 3648,
  [Color.LEGACY_OLIVE_GREEN]: 192,
  [Color.LEGACY_DARK_GREEN]: 256,
  [Color.LEGACY_DARK_TEAL]: 320,
  [Color.LEGACY_INDIGO]: 448,
  [Color.LEGACY_GREY_80_PERCENT]: 512,
  [Color.LEGACY_DARK_YELLOW]: 704,
  [Color.LEGACY_TEAL]: 832,
  [Color.LEGACY_BLUE_GREY]: 960,
  [Color.LEGACY_LIGHT_ORANGE]: 1152,
  [Color.LEGACY_SEA_GREEN]: 1280,
  [Color.LEGACY_AQUA]: 1344,
  [Color.LEGACY_LIGHT_BLUE]: 1408,
  [Color.LEGACY_GREY_40_PERCENT]: 1536,
  [Color.LEGACY_TURQUOISE]: 1856,
  [Color.LEGACY_SKY_BLUE]: 1920,
  [Color.LEGACY_ROSE]: 2112
};

// ForegroundColor

export const foregroundColorFormatByEncodedValue = {
  1: Color.GREY_4,
  // BLACK
  2: Color.BROWN_3,
  // BROWN
  6: Color.BLUE_4,
  // DARK_BLUE
  9: Color.RED_4,
  // DARK_RED
  10: Color.ORANGE_3,
  // ORANGE
  12: Color.GREEN_4,
  // GREEN
  14: Color.BLUE_3,
  // BLUE
  16: Color.GREY_3,
  // GREY_50_PRECENT
  17: Color.RED_3,
  // RED
  19: Color.GREEN_2,
  // LIME
  23: Color.PURPLE_4,
  // VIOLET
  25: Color.RED_2,
  // PINK
  26: Color.YELLOW_4,
  // GOLD
  27: Color.YELLOW_2,
  // YELLOW
  28: Color.GREEN_3,
  // BRIGHT_GREEN
  31: Color.PURPLE_3,
  // PLUM
  32: Color.GREY_2,
  // GREY_25_PERCENT
  34: Color.ORANGE_2,
  // TAN
  35: Color.YELLOW_1,
  // LIGHT_YELLOW
  36: Color.GREEN_1,
  // LIGHT_GREEN
  37: Color.BLUE_1,
  // LIGHT_TURQUOISE
  38: Color.BLUE_2,
  // PALE_BLUE
  39: Color.PURPLE_2,
  // LAVENDER
  40: Color.GREY_0,
  // WHITE
  41: Color.TRANSPARENT,
  42: Color.RED_0,
  43: Color.ORANGE_0,
  44: Color.YELLOW_0,
  45: Color.GREEN_0,
  46: Color.BLUE_0,
  47: Color.PURPLE_0,
  48: Color.BROWN_0,
  49: Color.RED_1,
  50: Color.ORANGE_1,
  51: Color.PURPLE_1,
  52: Color.BROWN_1,
  53: Color.GREY_1,
  54: Color.BROWN_2,
  55: Color.YELLOW_3,
  56: Color.ORANGE_4,
  57: Color.BROWN_4
};
export const encodedValueByForegroundColorFormat = {
  [Color.GREY_4]: 1,
  // BLACK
  [Color.BROWN_3]: 2,
  // BROWN
  [Color.BLUE_4]: 6,
  // DARK_BLUE
  [Color.RED_4]: 9,
  // DARK_RED
  [Color.ORANGE_3]: 10,
  // ORANGE
  [Color.GREEN_4]: 12,
  // GREEN
  [Color.BLUE_3]: 14,
  // BLUE
  [Color.GREY_3]: 16,
  // GREY_50_PRECENT
  [Color.RED_3]: 17,
  // RED
  [Color.GREEN_2]: 19,
  // LIME
  [Color.PURPLE_4]: 23,
  // VIOLET
  [Color.RED_2]: 25,
  // PINK
  [Color.YELLOW_4]: 26,
  // GOLD
  [Color.YELLOW_2]: 27,
  // YELLOW
  [Color.GREEN_3]: 28,
  // BRIGHT_GREEN
  [Color.PURPLE_3]: 31,
  // PLUM
  [Color.GREY_2]: 32,
  // GREY_25_PERCENT
  [Color.ORANGE_2]: 34,
  // TAN
  [Color.YELLOW_1]: 35,
  // LIGHT_YELLOW
  [Color.GREEN_1]: 36,
  // LIGHT_GREEN
  [Color.BLUE_1]: 37,
  // LIGHT_TURQUOISE
  [Color.BLUE_2]: 38,
  // PALE_BLUE
  [Color.PURPLE_2]: 39,
  // LAVENDER
  [Color.GREY_0]: 40,
  // WHITE
  [Color.TRANSPARENT]: 41,
  [Color.RED_0]: 42,
  [Color.ORANGE_0]: 43,
  [Color.YELLOW_0]: 44,
  [Color.GREEN_0]: 45,
  [Color.BLUE_0]: 46,
  [Color.PURPLE_0]: 47,
  [Color.BROWN_0]: 48,
  [Color.RED_1]: 49,
  [Color.ORANGE_1]: 50,
  [Color.PURPLE_1]: 51,
  [Color.BROWN_1]: 52,
  [Color.GREY_1]: 53,
  [Color.BROWN_2]: 54,
  [Color.YELLOW_3]: 55,
  [Color.ORANGE_4]: 56,
  [Color.BROWN_4]: 57,
  // Legacy Colors not supported, here for consistency
  [Color.LEGACY_OLIVE_GREEN]: 0,
  [Color.LEGACY_DARK_GREEN]: 0,
  [Color.LEGACY_DARK_TEAL]: 0,
  [Color.LEGACY_INDIGO]: 0,
  [Color.LEGACY_GREY_80_PERCENT]: 0,
  [Color.LEGACY_DARK_YELLOW]: 0,
  [Color.LEGACY_TEAL]: 0,
  [Color.LEGACY_BLUE_GREY]: 0,
  [Color.LEGACY_LIGHT_ORANGE]: 0,
  [Color.LEGACY_SEA_GREEN]: 0,
  [Color.LEGACY_AQUA]: 0,
  [Color.LEGACY_LIGHT_BLUE]: 0,
  [Color.LEGACY_GREY_40_PERCENT]: 0,
  [Color.LEGACY_TURQUOISE]: 0,
  [Color.LEGACY_SKY_BLUE]: 0,
  [Color.LEGACY_ROSE]: 0
};

// TaskbarColor

export const taskbarFormatbyEncodedValue = {
  1: Color.GREY_4,
  // BLACK
  2: Color.BROWN_3,
  // BROWN
  6: Color.BLUE_4,
  // DARK_BLUE
  9: Color.RED_4,
  // DARK_RED
  10: Color.ORANGE_3,
  // ORANGE
  12: Color.GREEN_4,
  // GREEN
  14: Color.BLUE_3,
  // BLUE
  16: Color.GREY_3,
  // GREY_50_PRECENT
  17: Color.RED_3,
  // RED
  19: Color.GREEN_2,
  // LIME
  23: Color.PURPLE_4,
  // VIOLET
  25: Color.RED_2,
  // PINK
  26: Color.YELLOW_4,
  // GOLD
  27: Color.YELLOW_2,
  // YELLOW
  28: Color.GREEN_3,
  // BRIGHT_GREEN
  31: Color.PURPLE_3,
  // PLUM
  32: Color.GREY_2,
  // GREY_25_PERCENT
  34: Color.ORANGE_2,
  // TAN
  35: Color.YELLOW_1,
  // LIGHT_YELLOW
  36: Color.GREEN_1,
  // LIGHT_GREEN
  37: Color.BLUE_1,
  // LIGHT_TURQUOISE
  38: Color.BLUE_2,
  // PALE_BLUE
  39: Color.PURPLE_2,
  // LAVENDER
  40: Color.GREY_0,
  // WHITE
  41: Color.TRANSPARENT,
  42: Color.RED_0,
  43: Color.ORANGE_0,
  44: Color.YELLOW_0,
  45: Color.GREEN_0,
  46: Color.BLUE_0,
  47: Color.PURPLE_0,
  48: Color.BROWN_0,
  49: Color.RED_1,
  50: Color.ORANGE_1,
  51: Color.PURPLE_1,
  52: Color.BROWN_1,
  53: Color.GREY_1,
  54: Color.BROWN_2,
  55: Color.YELLOW_3,
  56: Color.ORANGE_4,
  57: Color.BROWN_4,
  // LEGACY COLORS
  // no longer in palette but preserved for mapping to new colors
  3: Color.LEGACY_OLIVE_GREEN,
  4: Color.LEGACY_DARK_GREEN,
  5: Color.LEGACY_DARK_TEAL,
  7: Color.LEGACY_INDIGO,
  8: Color.LEGACY_GREY_80_PERCENT,
  11: Color.LEGACY_DARK_YELLOW,
  13: Color.LEGACY_TEAL,
  15: Color.LEGACY_BLUE_GREY,
  18: Color.LEGACY_LIGHT_ORANGE,
  20: Color.LEGACY_SEA_GREEN,
  21: Color.LEGACY_AQUA,
  22: Color.LEGACY_LIGHT_BLUE,
  24: Color.LEGACY_GREY_40_PERCENT,
  29: Color.LEGACY_TURQUOISE,
  30: Color.LEGACY_SKY_BLUE,
  33: Color.LEGACY_ROSE
};
export const encodedValueByTaskbarFormat = {
  [Color.GREY_4]: 1,
  // BLACK
  [Color.BROWN_3]: 2,
  // BROWN
  [Color.BLUE_4]: 6,
  // DARK_BLUE
  [Color.RED_4]: 9,
  // DARK_RED
  [Color.ORANGE_3]: 10,
  // ORANGE
  [Color.GREEN_4]: 12,
  // GREEN
  [Color.BLUE_3]: 14,
  // BLUE
  [Color.GREY_3]: 16,
  // GREY_50_PRECENT
  [Color.RED_3]: 17,
  // RED
  [Color.GREEN_2]: 19,
  // LIME
  [Color.PURPLE_4]: 23,
  // VIOLET
  [Color.RED_2]: 25,
  // PINK
  [Color.YELLOW_4]: 26,
  // GOLD
  [Color.YELLOW_2]: 27,
  // YELLOW
  [Color.GREEN_3]: 28,
  // BRIGHT_GREEN
  [Color.PURPLE_3]: 31,
  // PLUM
  [Color.GREY_2]: 32,
  // GREY_25_PERCENT
  [Color.ORANGE_2]: 34,
  // TAN
  [Color.YELLOW_1]: 35,
  // LIGHT_YELLOW
  [Color.GREEN_1]: 36,
  // LIGHT_GREEN
  [Color.BLUE_1]: 37,
  // LIGHT_TURQUOISE
  [Color.BLUE_2]: 38,
  // PALE_BLUE
  [Color.PURPLE_2]: 39,
  // LAVENDER
  [Color.GREY_0]: 40,
  // WHITE
  [Color.TRANSPARENT]: 41,
  [Color.RED_0]: 42,
  [Color.ORANGE_0]: 43,
  [Color.YELLOW_0]: 44,
  [Color.GREEN_0]: 45,
  [Color.BLUE_0]: 46,
  [Color.PURPLE_0]: 47,
  [Color.BROWN_0]: 48,
  [Color.RED_1]: 49,
  [Color.ORANGE_1]: 50,
  [Color.PURPLE_1]: 51,
  [Color.BROWN_1]: 52,
  [Color.GREY_1]: 53,
  [Color.BROWN_2]: 54,
  [Color.YELLOW_3]: 55,
  [Color.ORANGE_4]: 56,
  [Color.BROWN_4]: 57,
  // LEGACY COLORS
  // no longer in palette but preserved for mapping to new colors
  [Color.LEGACY_OLIVE_GREEN]: 3,
  [Color.LEGACY_DARK_GREEN]: 4,
  [Color.LEGACY_DARK_TEAL]: 5,
  [Color.LEGACY_INDIGO]: 7,
  [Color.LEGACY_GREY_80_PERCENT]: 8,
  [Color.LEGACY_DARK_YELLOW]: 11,
  [Color.LEGACY_TEAL]: 13,
  [Color.LEGACY_BLUE_GREY]: 15,
  [Color.LEGACY_LIGHT_ORANGE]: 18,
  [Color.LEGACY_SEA_GREEN]: 20,
  [Color.LEGACY_AQUA]: 21,
  [Color.LEGACY_LIGHT_BLUE]: 22,
  [Color.LEGACY_GREY_40_PERCENT]: 24,
  [Color.LEGACY_TURQUOISE]: 29,
  [Color.LEGACY_SKY_BLUE]: 30,
  [Color.LEGACY_ROSE]: 33
};
/* eslint-enable sort-keys*/

// Encode / Decode functions
export const decodeColorFormat = formatLookup => {
  return {
    backgroundColor: backgroundColorFormatByEncodedValue[formatLookup.backgroundColor],
    foregroundColor: foregroundColorFormatByEncodedValue[formatLookup.foregroundColor],
    taskbarColor: taskbarFormatbyEncodedValue[formatLookup.taskbarColor]
  };
};
export const encodeColorFormat = _ref => {
  let {
    backgroundColor,
    foregroundColor,
    taskbarColor
  } = _ref;
  const encodedValuesByColorFormat = {
    backgroundColor: backgroundColor ? encodedValueByBackgroundColorFormat[backgroundColor] : undefined,
    foregroundColor: foregroundColor ? encodedValueByForegroundColorFormat[foregroundColor] : undefined,
    taskbarColor: taskbarColor ? encodedValueByTaskbarFormat[taskbarColor] : undefined
  };
  return encodedValuesByColorFormat;
};
//# sourceMappingURL=Color.js.map